import React, { useState, useEffect } from 'react';
import FameMeter from '../partials/FameMeter';
const Conclusion = props => {
    // as animationFrame increments, new elements are animated into the scene
    const [animationFrame, setAnimationFrame] = useState(0);
    const totalScore = props.scoring.getTotalScore();
    // body3 is 100% correct, body2 is some correct, body1 is none correct
    function printResults() {
        let printWindow = window.open('', 'PRINT', 'height=600,width=400');
        printWindow.document.write('<html><head><title>' + props.data.certificateTitle  + '</title>');
        printWindow.document.write('</head><body>');
        printWindow.document.write('<link rel="stylesheet" href="./printcss.css">')
        printWindow.document.write('<div className="certificate">')
        printWindow.document.write('<p>' + props.data.header + '</p>')
        printWindow.document.write('<p>' + props.data.scoreText + totalScore + ' out of 300</p>')
        printWindow.document.write('<p>' + props.data.signOff + '</p>')
        printWindow.document.write('</div>')
        printWindow.document.write('</body></html>');
        // printWindow.print()
        // printWindow.close()
    }
    useEffect(() => {
        props.audioController.playAudioByName('courseConcl_2');

        setTimeout(() => {
            setAnimationFrame(1);
        }, 1000)
        setTimeout(() => {
            setAnimationFrame(2);
        }, 1500)
        setTimeout(() => {
            setAnimationFrame(3);
        }, 3000)
        return () => {
            props.onComplete();
            props.audioController.removeAllAudio();
        }
    }, [])
    
    return (
        <div className={`Conclusion`}>
            <div className={`site-content`}>
                <div className={`top-right-orange ${animationFrame > 0 ? 'slide-left' : ''}`} />
                <div className={`bottom-left-orange ${animationFrame > 1 ? 'slide-right' : ''}`} />
                <div className={`left-content`}>
                    <div className={`header`}>
                        <h2 dangerouslySetInnerHTML={{__html: props.data.header}}/>
                    </div>
                    <div className={`yellow-box`} />
                    <div className={`body-text`} dangerouslySetInnerHTML={{__html: props.data.body}} />
                    <FameMeter totalScore={props.scoring.getTotalScore()} data={props.data.fameMeter}/>
                    <div className={`body-text`} dangerouslySetInnerHTML={{__html: props.data.body2}} />
                </div>
                <div className={`truck-sunset`} />
                <div className={`global-button print-button`} onClick={window.print}>{props.data.printText}</div>
                <div className={`global-button retry-button`} onClick={() => { window.location.reload() }}>{props.data.retryText}</div>
                <a className={`global-button opinion-button`} onClick={props.onComplete} target='_blank' rel='noopener noreferrer'>{props.data.opinionText}</a>
            </div>
            <div className={`print-content`}>
                <div className={`certificate`}>
                    <div className={`text-content`}>
                        {props.sharedData.learnerName && props.sharedData.learnerName.length > 0 && 
                        <p>Name: {props.sharedData.learnerName}</p>
                        }
                        <p dangerouslySetInnerHTML={{__html: props.data.header}} />
                        <p><span dangerouslySetInnerHTML={{__html: props.data.scoreText}} />{`${totalScore} out of 300`}</p>
                        <p dangerouslySetInnerHTML={{__html: props.data.signOff}} />
                    </div>
                    <img src='assets/img/certificate.png' alt="Certificate of completion background" />
                </div>
            </div>
        </div>
    )
}

export default Conclusion